import { defineMessages } from '@transcend-io/internationalization';

export const emailFormInputMessages = defineMessages(
  'privacy-center.components.EmailFormInput.emailFormInput',
  {
    emailPlaceholder: {
      defaultMessage: 'Enter your email address',
      description:
        'Placeholder text for the email address input on Privacy Center.',
    },
  },
);
